<template>
  <div class="flex w-[548px] flex-col items-start gap-5 self-stretch">
    <section class="flex flex-col items-start gap-2 self-stretch">
      <UITextSmMedium>{{ t("common.iframeEmbed") }}</UITextSmMedium>
      <UIInput id="iFrameurl" :model-value="iframeUrl" type="textarea" :rows="7" readonly>
        <template #suffix
          ><Copy01Icon
            class="h-5 w-5 cursor-pointer"
            :class="activeClass"
            @click="copyLink" /></template
      ></UIInput>
    </section>
  </div>
</template>

<script setup lang="ts">
import config from "@/config";
import { useAppStore } from "@/store/app";
import { sleep, openLinkInNewTab } from "@/util/methods";
import { Copy01Icon } from "@gohighlevel/ghl-icons/24/outline";
import { UIInput, UITextSmMedium } from "@gohighlevel/ghl-ui";
import { ref } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();
const store = useAppStore();

const props = defineProps({
  isWhiteLabelled: {
    type: Boolean,
    required: true,
  },
  name: {
    type: String,
    required: true,
  },
  widgetName: {
    type: String,
    required: true,
  },
  widgetId: {
    type: String,
    required: true,
  },
  baseUrl: {
    type: String,
    required: true,
  },
});

const embedUrl = ref();
const iframeUrl = ref();
const activeClass = ref("text-black-600");

createEmbedUrl();

const copyLink = async () => {
  activeClass.value = "text-blue-600";
  store.copyToClipBoard(iframeUrl.value);
  await sleep(6000);
  activeClass.value = "text-black-600";
};

function createEmbedScriptUrl() {
  if (props.isWhiteLabelled && process.env.NODE_ENV !== "beta") {
    return `${props.baseUrl}/js`;
  }
  return config.FORM_EMBED_URL;
}

function createEmbedUrl() {
  if (process.env.NODE_ENV === "development") {
    embedUrl.value = `http://localhost:3344/widget/${props.widgetName}/${props.widgetId}`;
  } else {
    embedUrl.value = props.baseUrl + `/widget/${props.widgetName}/${props.widgetId}`;
  }

  iframeUrl.value = `<iframe src="${
    embedUrl.value
  }" style="border:none;width:100%;" scrolling="no" id="${props.widgetId}" title="${
    props.widgetName
  }"></iframe>\n<script src="${createEmbedScriptUrl()}/form_embed.js"><\/script>`;
}

const redirectToFunnel = async (url) => {
  store.copyToClipBoard(iframeUrl.value);
  await sleep(1000);
  openLinkInNewTab(url);
};
</script>
